import { push,replace } from 'connected-react-router'

export function redirectTo(page,dispatch){    
    return dispatch(push(page));
}

// Remove the URL from the history if its not required to load again from history or back button
export function removeHistoryAndredirectTo(page,dispatch){  
    return dispatch(replace(page));
}